import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import React, { Suspense, useEffect, useState } from 'react';

import { queryClient } from './queryClient';

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
);

export const QueryClientProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [showDevtools, setShowDevtools] = useState(import.meta.env.DEV);

  useEffect(() => {
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
      {showDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </Suspense>
      )}
    </TanstackQueryClientProvider>
  );
};
